import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxMediaAnalyticsService } from './media-analytics.service';

export const ngxMediaAnalyticsServiceModule = angular.module('ngxMediaAnalyticsServiceModule', [])
	.factory('ngxMediaAnalyticsService', downgradeInjectable(NgxMediaAnalyticsService) as any)
	.name;
